import React from "react";
import { Circle, OptionsWrapper, OrderOptions, RadiosWrapper, RadiusButton, SimpleChartContainer, Text, Title } from "./style";
import { BAR, FUNNEL, PIE } from "src/components/Charts/types";
import { Order } from "src/sections/ReportManager/constants";

export const ReportSimpleChart = ({
  onChartEdit,
  chartData
}) => {

  const handleCheck = (type, order = Order.DESC) => {
    let newChartData;
    if (type === BAR) {
      newChartData = {...chartData, render: type, order};
    } else {
      newChartData = {...chartData, render: type};
    }
    onChartEdit(newChartData);
  }

  return (
    <SimpleChartContainer>
      <Title>Selecione o modelo de gráfico a ser exibido</Title>
      <OptionsWrapper>
        <RadiosWrapper isSmall={false} onClick={() => handleCheck(PIE)}>
          <RadiusButton>
            <Circle isSmall={false} isChecked={chartData.render === PIE}/>
          </RadiusButton>
          <Text>Modelo de gráfico de pizza</Text>
        </RadiosWrapper>
      </OptionsWrapper>

      <OptionsWrapper>
          <RadiosWrapper isSmall={false} onClick={() => handleCheck(BAR)}>
            <RadiusButton>
              <Circle isSmall={false} isChecked={chartData.render === BAR} />
            </RadiusButton>
            <Text>Modelo de gráfico de barras</Text>
          </RadiosWrapper>

          <OrderOptions>
            <RadiosWrapper isSmall onClick={() => handleCheck(BAR, Order.DESC)}>
              <RadiusButton>
                <Circle isSmall isChecked={chartData.order === Order.DESC} />
              </RadiusButton>
              <Text>Ordenar do maior valor para o menor</Text>
            </RadiosWrapper>

            <RadiosWrapper isSmall onClick={() => handleCheck(BAR, Order.ASC)}>
              <RadiusButton>
                <Circle isSmall isChecked={chartData.order === Order.ASC} />
              </RadiusButton>
              <Text>Ordenar do menor valor para o maior</Text>
            </RadiosWrapper>
          </OrderOptions>
      </OptionsWrapper>

      <OptionsWrapper>
          <RadiosWrapper isSmall={false} onClick={() => handleCheck(FUNNEL)}>
            <RadiusButton>
              <Circle isSmall={false} isChecked={chartData.render === FUNNEL} />
            </RadiusButton>
            <Text>Modelo de gráfico de funil</Text>
          </RadiosWrapper>
      </OptionsWrapper>
    </SimpleChartContainer>
  );
}